// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"OnboardingVerifyEmailForm_fieldset__1V5v8","footer":"OnboardingVerifyEmailForm_footer__3nUA0","link":"OnboardingVerifyEmailForm_link__SbI_6"};